var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"797px"}},[_c('v-carousel',{staticClass:"rounded-xl",attrs:{"cycle":"","show-arrows":false,"height":"446"}},_vm._l((_vm.bannerList),function(item,i){return _c('v-carousel-item',{key:i},[_c('v-img',{attrs:{"src":_vm.BigImg(item.url_pc),"alt":""},on:{"click":function($event){_vm.gotoGame(
            item.url,
            item.url_type,
            item.banner_type,
            parseInt(item.id)
          );}}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }